module.exports = __webpack_public_path__ + "static/media/loader.b1cb5350.svg";